import { put } from 'redux-saga/effects';
import { getInsuranceCompanyBySlugSuccess, getInsuranceCompanyBySlugFailure } from 'redux/actions';
import { getInsuranceCompanyBySlugApiRequest } from 'api/balloon';

export function* getInsuranceCompanyBySlugSaga(action) {
  try {
    const { slug } = action.payload;
    const { data: response } = yield getInsuranceCompanyBySlugApiRequest({ slug });

    if (response.errors) {
      yield put(getInsuranceCompanyBySlugFailure(response.errors));
      return;
    }
    yield put(
      getInsuranceCompanyBySlugSuccess({
        insuranceCompany: response.data.insuranceCompanies?.[0] || null
      })
    );
  } catch (error) {
    yield put(getInsuranceCompanyBySlugFailure(error));
  }
}
